import { render, staticRenderFns } from "./TeamBottomSheet.vue?vue&type=template&id=36a10d27&scoped=true"
import script from "./TeamBottomSheet.vue?vue&type=script&lang=js"
export * from "./TeamBottomSheet.vue?vue&type=script&lang=js"
import style0 from "./TeamBottomSheet.vue?vue&type=style&index=0&id=36a10d27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a10d27",
  null
  
)

export default component.exports